import { useTheme } from 'styled-components';

import { Paragraph } from '@/core/components/Typography';

import { MetadataField, MetadataFieldLabel } from './AnalysisViewModal.styles';
import { MetadataFieldItemProps } from '../../interfaces';

export function MetadataFieldItem({ label, variant = 'text', children }: MetadataFieldItemProps) {
  const { colors } = useTheme();

  if (children == null) return null;

  if (variant === 'text' && typeof children === 'string' && children.trim() === '') {
    return null;
  }

  const content = variant === 'text' ? <Paragraph type="normal">{children}</Paragraph> : children;

  return (
    <MetadataField>
      <MetadataFieldLabel>
        <Paragraph
          type="normal"
          color={colors.secondaryText}
        >
          {label}
        </Paragraph>
      </MetadataFieldLabel>
      {content}
    </MetadataField>
  );
}
